// Ambil kode HTTP dan pesan error backend dari error axios.
// Backend DOS membalas {resultCd, message, result:false}; untuk request
// responseType "blob" (PDF) body error juga datang sebagai Blob.

export const getHttpStatus = (error: unknown): number | undefined =>
  (error as { response?: { status?: number } } | null)?.response?.status;

const readBlobText = (blob: Blob): Promise<string> => {
  if (typeof blob.text === "function") return blob.text();

  // jsdom (test) belum punya Blob.text()
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result ?? ""));
    reader.onerror = () => reject(reader.error);
    reader.readAsText(blob);
  });
};

/** Pesan backend apa adanya; `fallback` jika tidak ada pesan. */
export const getApiErrorMessage = async (error: unknown, fallback: string) => {
  const data = (error as { response?: { data?: unknown } } | null)?.response?.data;

  try {
    if (typeof Blob !== "undefined" && data instanceof Blob) {
      const parsed = JSON.parse(await readBlobText(data));
      return typeof parsed?.message === "string" && parsed.message ? parsed.message : fallback;
    }
  } catch {
    return fallback;
  }

  const message = (data as { message?: unknown } | undefined)?.message;
  return typeof message === "string" && message ? message : fallback;
};
